import { render } from "./KeyF2.vue?vue&type=template&id=167ea8d6"
import script from "./KeyF2.vue?vue&type=script&lang=ts"
export * from "./KeyF2.vue?vue&type=script&lang=ts"
script.render = render

export default script